var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
var messages = defineMessages({
    profile_unsettled_bets: {
        id: "profile.logout",
        defaultMessage: "Logout"
    },
});
var SignOut = function (props) {
    return (_jsx("a", __assign({ href: "#", className: "user-menu__nav__item", onClick: props.signOut }, { children: _jsx(FormattedMessage, __assign({}, messages.profile_unsettled_bets)) })));
};
SignOut.propTypes = {
    signOut: PropTypes.func.isRequired
};
export default SignOut;



// WEBPACK FOOTER //
// ./src/components/sidebar/SignOut.jsx